import { Box, Typography } from '@mui/material';
import { useState, useEffect } from 'react';
import { styles } from '../assets/styles';

const daysOfWeek = {
  lunes: 'Monday',
  martes: 'Tuesday',
  miércoles: 'Wednesday',
  jueves: 'Thursday',
  viernes: 'Friday',
  sábado: 'Saturday',
  domingo: 'Sunday',
};

export function HistoryPokemon() {
  const [guessHistory, setGuessHistory] = useState([]);

  useEffect(() => {
    const storedGuesses = JSON.parse(localStorage.getItem('guesses'));

    if (storedGuesses) {
      const history = Object.keys(storedGuesses).map((name) => {
        const guess = storedGuesses[name];

        const dateComponents = guess.date.split('/');
        const year = dateComponents[2];
        const month = dateComponents[1] - 1;
        const day = dateComponents[0];
        const hour = parseInt(guess.hour, 10);
        const minute = parseInt(guess.minute, 10);

        const date = new Date(year, month, day, hour, minute);

        const dayName = guess.day;
        const dayNameEnglish = daysOfWeek[dayName.toLowerCase()];

        const dateString = date.toLocaleDateString('en-US');
        const timeString = date.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          hour12: true,
        });

        return {
          name,
          date: dateString,
          dayName: dayNameEnglish,
          hourMoment: timeString,
        };
      });

      setGuessHistory(history);
    }
  }, []);

  return (
    <Box sx={styles.historyContainer}>
      {guessHistory.reverse().map(({
        name, date, dayName, hourMoment,
      }, index) => (
        <Box key={index} style={styles.boxInlineBackground}>
          <Typography variant="h4" sx={styles.statsInlineTypography}>
            {dayName}
            {' '}
            {hourMoment}
            {' '}
            <br />
            {date}
            :
            <span style={styles.historySpan}>{name}</span>
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export function HistoryPokemonCries() {
  const [guessHistory, setGuessHistory] = useState([]);

  useEffect(() => {
    const storedGuesses = JSON.parse(localStorage.getItem('guesses_cries'));

    if (storedGuesses) {
      const history = Object.keys(storedGuesses).map((name) => {
        const guess = storedGuesses[name];

        const dateComponents = guess.date.split('/');
        const year = dateComponents[2];
        const month = dateComponents[1] - 1;
        const day = dateComponents[0];
        const hour = parseInt(guess.hour, 10);
        const minute = parseInt(guess.minute, 10);

        const date = new Date(year, month, day, hour, minute);

        const dayName = guess.day;
        const dayNameEnglish = daysOfWeek[dayName.toLowerCase()];

        const dateString = date.toLocaleDateString('en-US');
        const timeString = date.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          hour12: true,
        });

        return {
          name,
          date: dateString,
          dayName: dayNameEnglish,
          hourMoment: timeString,
        };
      });

      setGuessHistory(history);
    }
  }, []);
  return (
    <Box sx={styles.historyContainer}>
      {guessHistory.reverse().map(({
        name, date, dayName, hourMoment,
      }, index) => (
        <Box key={index} sx={styles.boxInlineBackground}>
          <Typography variant="h4" sx={styles.statsInlineTypography}>
            {dayName}
            {' '}
            {hourMoment}
            {' '}
            <br />
            {date}
            :
            <span style={styles.historySpan}>{name}</span>
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export function HistoryPokemonEmoji() {
  const [guessHistory, setGuessHistory] = useState([]);

  useEffect(() => {
    const storedGuesses = JSON.parse(localStorage.getItem('guesses_emoji'));

    if (storedGuesses) {
      const history = Object.keys(storedGuesses).map((name) => {
        const guess = storedGuesses[name];

        const dateComponents = guess.date.split('/');
        const year = dateComponents[2];
        const month = dateComponents[1] - 1;
        const day = dateComponents[0];
        const hour = parseInt(guess.hour, 10);
        const minute = parseInt(guess.minute, 10);

        const date = new Date(year, month, day, hour, minute);

        const dayName = guess.day;
        const dayNameEnglish = daysOfWeek[dayName.toLowerCase()];

        const dateString = date.toLocaleDateString('en-US');
        const timeString = date.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          hour12: true,
        });

        return {
          name,
          date: dateString,
          dayName: dayNameEnglish,
          hourMoment: timeString,
        };
      });

      setGuessHistory(history);
    }
  }, []);

  return (
    <Box sx={styles.historyContainer}>
      {guessHistory.reverse().map(({
        name, date, dayName, hourMoment,
      }, index) => (
        <Box key={index} sx={styles.boxInlineBackground}>
          <Typography variant="h4" sx={styles.statsInlineTypography}>
            {dayName}
            {' '}
            {hourMoment}
            {' '}
            <br />
            {date}
            :
            <span style={styles.historySpan}>{name}</span>
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
